<template>
  <path pid="0" d="M13 1a3.5 3.5 0 00-3.5 3.5v10.76A5.5 5.5 0 0013 25a5.5 5.5 0 003.48-9.74V4.5A3.5 3.5 0 0013 1zm3.35 19.52a3.5 3.5 0 11-5.29-3.93 1 1 0 00.44-.83V4.5a1.5 1.5 0 013 0v11.26a1 1 0 00.44.83 3.49 3.49 0 011.41 3.93z"/>
</template>
